import { render, staticRenderFns } from "./AgreementAutocomplete.vue?vue&type=template&id=a5fffa2c&scoped=true&"
import script from "./AgreementAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./AgreementAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fffa2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
